import { render, staticRenderFns } from "./AppKanbanColumnHeader.vue?vue&type=template&id=8ab813ce&scoped=true"
import script from "./AppKanbanColumnHeader.vue?vue&type=script&lang=js"
export * from "./AppKanbanColumnHeader.vue?vue&type=script&lang=js"
import style0 from "./AppKanbanColumnHeader.vue?vue&type=style&index=0&id=8ab813ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ab813ce",
  null
  
)

export default component.exports